import { render, staticRenderFns } from "./ConfigBrandDialogVersion2.vue?vue&type=template&id=0e15f653&scoped=true"
import script from "./ConfigBrandDialogVersion2.vue?vue&type=script&lang=js"
export * from "./ConfigBrandDialogVersion2.vue?vue&type=script&lang=js"
import style0 from "./ConfigBrandDialogVersion2.vue?vue&type=style&index=0&id=0e15f653&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e15f653",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e15f653')) {
      api.createRecord('0e15f653', component.options)
    } else {
      api.reload('0e15f653', component.options)
    }
    module.hot.accept("./ConfigBrandDialogVersion2.vue?vue&type=template&id=0e15f653&scoped=true", function () {
      api.rerender('0e15f653', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/dialog/ConfigBrandDialogVersion2.vue"
export default component.exports